import { c as _c } from "react/compiler-runtime";
import useModalStore from '@module/stores/useModalStore';
import { Modal } from '@pc/components/modal/modal';
import { Calendar } from '@pc/components/ui/calendar';
import type { DayPickerSingleProps } from 'react-day-picker';
interface Props extends Omit<DayPickerSingleProps, 'mode'> {
  title: string;
  selected: Date;
}
function DatePickerModal(t0) {
  const $ = _c(13);
  let props;
  let title;
  if ($[0] !== t0) {
    ({
      title,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = title;
  } else {
    props = $[1];
    title = $[2];
  }
  const {
    popModal
  } = useModalStore();
  let t1;
  if ($[3] !== popModal) {
    t1 = <Modal.Close onClick={popModal} />;
    $[3] = popModal;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1 || $[6] !== title) {
    t2 = <Modal.Header><Modal.Title className="flex items-center justify-between">{title}{t1}</Modal.Title></Modal.Header>;
    $[5] = t1;
    $[6] = title;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== props) {
    t3 = <Modal.Content className=""><Calendar mode="single" required={true} {...props} /></Modal.Content>;
    $[8] = props;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <Modal.Container className="w-[432px]">{t2}{t3}</Modal.Container>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}
export default DatePickerModal;